import { IGetState, TBoardId, TCardId } from '../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { uploadFiles } from '../effects/uploadFiles';
import { attachmentPastedSegmentEvent, attachmentPasteErrorSegmentEvent } from '../effects/segmentEffects';
import {
    SegmentCardEvent,
    SegmentCardPasteFileTarget
} from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';
import { ERestDriveDocType } from '../../../../../../../../types/rest/IRestDriveDoc';
import { IDriveDoc } from '../../../../../../../../store/model/card/types/IDriveDoc';
import { segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { commentUpdate } from '../../../../../../base/components/Comments/store/reducers/actions/commentUpdate';
import { snackbarErrorReload } from 'app/view/react_components/snackbarsStack';

export const onPasteFileAsComment = (
    cardId: TCardId,
    files: File[],
    onProgress: (percent: number) => void
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (!files) {
            return dispatch(attachmentPasteErrorSegmentEvent(SegmentCardPasteFileTarget.COMMENT));
        }

        dispatch(attachmentPastedSegmentEvent(SegmentCardPasteFileTarget.COMMENT));
        dispatch(segmentTrackAction(SegmentCardEvent.COMMENT_ATTACHMENT_PASTE));
        return dispatch(uploadFiles(cardId, files, onProgress, true, ERestDriveDocType.COMMENT))
            .then((driveDocs: IDriveDoc[]) => {
                dispatch(commentUpdate({ droppedAttachmentIds: driveDocs.map(driveDoc => driveDoc.id) }));
            })
            .catch((e: any)=>{
                dispatch(snackbarErrorReload(true, `Error: ${e.message? e.message: JSON.stringify(e)}`));
            });
    };
    return action;
};
